<script setup lang="ts">
interface Props {
    icon: string
    size?: string | number
    class?: string
}

const props = withDefaults(defineProps<Props>(), {
    size: '20',
    class: ''
})
</script>

<template>
    <v-tooltip
        location="bottom"
        content-class="bg-black border-sm text-tooltip"
        max-width="200"
    >
        <template #activator="{ props: bind }">
            <v-icon
                v-bind="bind"
                :size="props.size"
                :class="props.class"
            >
                {{ props.icon }}
            </v-icon>
        </template>
        <slot />
    </v-tooltip>
</template>

<style scoped>

</style>
